import type { TranslationCatalog } from "../types.js";
import { pluralBcs } from "../plural.js";

// Pannonian Rusyn (Vojvodina Cyrillic standard). Lowest-confidence catalog of
// the ten — a minority language with limited digital/gaming reference
// material available; flagged for native-speaker review before wider launch.
function coinWord(n: number): string {
  return pluralBcs(n, ["новчіч", "новчічі", "новчічів"]);
}

export default {
  "common.loading": "Конектованє...",
  "common.loadingEllipsis": "Вчитованє...",
  "common.unknownError": "Незнама хиба",
  "common.errorPrefix": (p: { message: string }) => `Хиба: ${p.message}`,
  "common.retry": "Спробуй знову",
  "common.close": "Затворь",
  "common.back": "← Наспак",
  "common.cancel": "Одкажи",
  "common.details": "Подробносци",
  "common.settingsTitle": "⚙️ Наставованя",
  "common.profile": "👤 Профил",
  "common.rules": "📖 Правила",

  "login.subtitle": "Приявй ше, жебы грав.",
  "login.continueFacebook": "Продовж з Facebook контом",
  "login.continueGoogle": "Продовж з Google контом",
  "login.continueEmail": "Продовж з email адресу",
  "login.tagline": "Картова гра з адутом и лицитацию за трох гарчох. Лицитуй, вибер адута и однес штихи — перши до 101 бода вигра.",
  "login.linkRules": "Правила",
  "login.linkStrategy": "Стратегия",
  "login.linkAbout": "О гри",
  "login.linkPrivacy": "Приватносц",

  "lobby.entryFee": (p: { fee: number }) => `Уступне за парцию: ${p.fee} ${coinWord(p.fee)}`,
  "lobby.resumeMatch": "Продовж парцию",
  "lobby.playButton": "Грай (3 грачі)",
  "lobby.inviteFriend": "📣 Поволай приятеля",
  "lobby.insufficientFunds": (p: { missing: number }) => `Нємаш досц новчічів за уступне (хиби ${p.missing}).`,
  "lobby.watchAd": "Позри рекламу за додатни новчічі",

  "leaderboard.title": "🏆 Ранґ-листа",
  "leaderboard.emptySeason": "Ище нєт рангованих грачів у тей сезони (треба одограц бримінь 1 парцию).",
  "leaderboard.emptyGlobal": "Ище нєт рангованих грачів (треба одограц бримінь 1 парцию вєдно).",
  "leaderboard.seasonTabDefault": "Сезона",
  "leaderboard.seasonTabWithDate": (p: { month: string; year: string }) => `Сезона ${p.month}/${p.year}`,
  "leaderboard.globalTab": "🌍 Вєдно (шицки сезони)",
  "leaderboard.colPlayer": "Грач",
  "leaderboard.colPoints": "Боди",
  "leaderboard.colMatches": "Парциї",
  "leaderboard.you": "Ти",
  "leaderboard.yourScoreUnranked": (p: { points: number; matchesPlayed: number }) =>
    `Твой резултат: ${p.points} боди з ${p.matchesPlayed} парцийох (треба бримінь 1 парция за ранґ)`,

  "rules.title": "📖 Як ше грає Мексіко",
  "rules.cardsHeading": "Карти",
  "rules.cardsBody":
    "Грає ше з 32 картами (7, 8, 9, 10, J, Q, K, A у шицких 4 фарбох). Моц карти у рамикох фарби, од найслабшей: 7 &lt; 8 &lt; 9 &lt; 10 &lt; J &lt; Q &lt; K &lt; A. Адутска фарба бере шицки не-адутски карти, без огляду на ранг.",
  "rules.dealingHeading": "Дзелєнє",
  "rules.dealingBody": 'Кажди з 3 грачох достава 10 карти (у двох рундох по 5), а 2 карти остаю скрити у "купу".',
  "rules.biddingHeading": "Лицитация",
  "rules.biddingBody":
    'Перши грач муши лицитовац бримінь 5. Кажди пришли муши лицитовац стрикно вецей (5, 6, 7, 8, 9, 10, або "МЕКСІКО") або повесц "дальше" — хто раз повесц "дальше", трвало випада з лицитациї за тото дзелєнє. Лицитация ше закончує кед остава лєм єден грач.',
  "rules.talonHeading": "Куп и одкладанє",
  "rules.talonBody":
    "Побиднїк лицитациї одтвара куп (2 карти, видлїви шицким), додава их до своєй руки (тераз ма 12 карти), потим одкладать 2 карти долу твару. Потим бере адутску фарбу.",
  "rules.mexicoHeading": "МЕКСІКО (20)",
  "rules.mexicoBody":
    'Хто лицитує "МЕКСІКО", обовязує ше же возьме шицких 10 штихох. Грає ше без адута и без купу — лєм з оригиналнима 10 картами.',
  "rules.tricksHeading": "Тог гри (штихи)",
  "rules.tricksBody":
    "Муши ше слїдзиц винєшену фарбу, кед ю маш. Кед ю нємаш, муши ше кинуц адут, кед го маш (сцінанє) — лєм кед нємаш нїч з того, можеш кинуц цо гоч. Штих бере найсильнєйша карта винєшеней фарби, окрем кед хтош кинул адут — теди найсильнєйши адут бере, без огляду на фарбу. Хто возьме штих, водзи у пришлим.",
  "rules.scoringHeading": "Бодованє",
  "rules.scoringBody":
    "Побиднїк лицитациї: кед возьме бримінь тельо штихи кельо лицитовал, достава тельо боди кельо направду взял. Кед ше му нє удало, достава <strong>неґативни</strong> боди у висоти лицитациї. Остатнї два грачі задумовно доставаю боди єднаки чіслу штихох цо их взяли.",
  "rules.matchEndHeading": "Конєц парциї",
  "rules.matchEndBody":
    "Парция ше закончує кед хтош дошягнє циляни резултат. Кед вецей грачі пременю циль у истим дзелєню з истим найвисшим резултатом, ше грає додатне дзелєнє покля ше нє розришел.",

  "settings.soundOff": "🔇 Гук виключени",
  "settings.soundOn": "🔊 Гук уключени",
  "settings.displayNameLabel": "Мено у грі",
  "settings.saveDisplayName": "Спамятай мено",
  "settings.displayNameLengthError": "Мено муши мац 1-20 знакох.",
  "settings.saveFailed": "Спамятованє нє удане, спробуй знову.",
  "settings.logout": "🚪 Одгласити ся",

  "waitingRoom.waitingForPlayers": (p: { filled: number; total: number }) => `Чеканє на грачі... ${p.filled}/${p.total}`,
  "waitingRoom.countdown": (p: { remainingSec: number }) => `Остало ${p.remainingSec}с покля AI нє наполнї пусти месца`,

  "game.passLabel": "дальше",
  "game.passButton": "Дальше",
  "game.mexicoLabel": "МЕКСІКО",
  "game.bidLabel": (p: { bid: string }) => `Лицитация: ${p.bid}`,
  "game.trumpLabel": (p: { suit: string }) => `Адут: ${p.suit}`,
  "game.tricksWonLabel": (p: { count: number }) => `Штихи: ${p.count}`,
  "game.biddingInProgress": "Лицитация тераз тирва...",
  "game.yourBid": "Твоя лицитация",
  "game.someoneDiscarding": (p: { name: string }) => `${p.name} одкладать карти...`,
  "game.someoneChoosingTrump": (p: { name: string }) => `${p.name} бере адута...`,
  "game.chooseTrumpPrompt": "Вибер адута",
  "game.nextDealPause": "Пришле дзелєнє...",
  "game.fromTalon": "з купу",
  "game.talonRevealLabel": (p: { bidder: string }) => `Карти з купу (${p.bidder})`,
  "game.yourTurnLabel": "Твой ряд",
  "game.turnTimerLabel": (p: { name: string; remainingSec: number }) => `${p.name} — ${p.remainingSec}с`,
  "game.idleBotTakeover": "🤖 Нє одограв/-ла ши на час потяг, тераз намисто тебе грає AI. Клїкнї дзе гоч жебы преберал контролу.",
  "game.leaveMatch": "Опущ парцию",
  "game.cardAlt": "карта",
  "game.botDisplayName": "AI грач",
  "game.botBadgeIdle": "🤖 AI (провизорично)",
  "game.botBadgeFull": "🤖 БОТ",
  "game.declarerTooltip": "Водзи лицитацию",

  "matchEnd.title": "Парция закончена",
  "matchEnd.winner": (p: { name: string }) => `Побиднїк: ${p.name}`,
  "matchEnd.backToLobby": "Наспак до лоби",

  "reactions.sendButton": "Пошлї реакцию",
  "reaction.angry_small_card": "Прецо з малу картом?",
  "reaction.angry_big_card": "Прецо з великом картом?",
  "reaction.bravo": "Браво",
  "reaction.svaka_cast": "Капа долу",
  "reaction.cestitam_pobeda": "Чещитам на побиди",
  "reaction.izvini": "Прешинь",
  "reaction.pa_zasto": "Та прецо!",
  "reaction.srecan": "",
  "reaction.srce": "",
  "reaction.pozdrav": "",

  "medal.season_gold": "🥇 Сезона",
  "medal.season_silver": "🥈 Сезона",
  "medal.season_bronze": "🥉 Сезона",
  "medal.first_match": "🎉 Перша парция",
  "medal.matches_100": "💯 100 парцийох",
  "medal.mexico_master": "🌵 Мексіко майстор",
  "medal.hat_trick_3_wins": "🔥 Хетрик (3 побиди)",
  "medal.tricks_1000": "🃏 1000 штихох",

  "suit.diamonds": "Каро",
  "suit.hearts": "Серце",
  "suit.clubs": "Треф",
  "suit.leaves": "Лїст",

  "profile.matchesPlayed": "Одограни парциї",
  "profile.firstPlace": (p: { wins: number }) => `🥇 1. место (${p.wins})`,
  "profile.secondPlace": (p: { count: number }) => `🥈 2. место (${p.count})`,
  "profile.thirdPlace": (p: { count: number }) => `🥉 3. место (${p.count})`,
  "profile.pointsConfigNote": (p: { win: number; second: number; third: number }) =>
    `Бодованє за парцию: 1. место ${p.win}, 2. место ${p.second}, 3. место ${p.third} боди`,
  "profile.noMedals": "Ище нєт освойованих медальох.",
  "profile.medalsHeading": "Медальи",
  "profile.seasonHistoryHeading": "История сезонох",
  "profile.colSeason": "Сезона",
  "profile.colRank": "Ранґ",
  "profile.deleteAccountButton": "🗑️ Видали конто",
  "profile.deleteAccountTitle": "Видали конто",
  "profile.deleteAccountWarning":
    "Тото трвало видалює твоє конто и вшыткы податки (історию партий, ранг-листу, медалї, стан новчічів). Тота акция ся нє дац одвола.",
  "profile.deleteAccountConfirm": "Гей, видали конто",
  "profile.deleteAccountFailed": "Видаленє нє удане, спробуй знову.",
  "profile.deleteAccountActiveMatch": "Нє можеш видалиц конто док ши в активней партиї. Закончи або опущ партию та спробуй знову.",

  "errors.NOT_YOUR_TURN": "Нє твой ряд.",
  "errors.INVALID_BID": "Невалидна лицитация.",
  "errors.BID_TOO_LOW": "Лицитация муши буц векша од тераз найвисшей.",
  "errors.MUST_BID_FIRST": "Перши грач муши лицитовац бримінь 5, нє може повесц дальше.",
  "errors.DUPLICATE_DISCARD": "Нє можеш одложиц исту карту два раз.",
  "errors.CARD_NOT_IN_HAND": "Тота карта нєт у твоєй руки.",
  "errors.MUST_FOLLOW_SUIT": "Муши ше слїдзиц фарбу, або сцінац адутом кед нє можеш.",
  "errors.TRICK_INCOMPLETE": "Штих ище нє закончени.",
  "errors.MATCH_ENDED": "Парция ше вец закончела.",
  "errors.UNKNOWN_ACTION": "Незнама акция.",
  "errors.WRONG_PHASE": "Тота акция нє дошлєбодзена у тей фази гри.",
  "errors.NOT_BID_WINNER": "Лєм побиднїк лицитациї то може зробиц.",
  "errors.MATCH_NOT_ENDED": "Парция ище ше нє закончела.",
  "errors.invalid_session_token": "Сесия ше скончела, приявй ше знову.",
  "errors.room_full": "Стол ше наполнєни, спробуй знову за хвильку.",
  "errors.insufficient_balance": "Нємаш досц новчічів за уступне.",
  "errors.ad_unavailable": "Реклама теперь нєприступна. Перевір інтернетове спойіня (або выпни AdBlock) і попробуй знову.",
  "errors.invalid_or_early_ticket": "Реклама не была узнана як одогляджена. Попробуй знову.",
  "errors.daily_ad_limit_reached": "Досяг ес денну границю реклам. Попробуй завтра.",

  "share.inviteText": "Грай Мексіко зо мном!",
  "ad.placeholderText": "Симуловна реклама (standalone веб демо)",
  "rotateOverlay.text": "Обрац телефон жебы грав Мексіко",
  "languageSwitcher.ariaLabel": "Язик",
} satisfies TranslationCatalog;
